/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/cognitive-complexity */
// eslint-disable-next-line import/no-extraneous-dependencies
// import InfiniteScroll from 'react-infinite-scroll-component';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Col, Input, message as toaster } from 'antd';
import { MessageOutlined, FilterFilled } from '@ant-design/icons';
import { Box, Button, Flex, Text } from 'atoms';
import { getPodList } from 'store/approvalSlice';
import { SVG } from 'utils';
import { PopoverWrapper, PopoverButton, PodViewerModal } from 'components';
import { formatApprovalDate, formatApprovalTime } from 'utils/approvalDateTime';

export default function PODTaskForm() {
	const dispatch = useDispatch();
	const [DataSource, setDataSource] = useState([]);
	const [total_count, setTotalCount] = useState(0);
	const [limit, SetLimit] = useState(10);
	const [filter, setFilter] = useState('');
	useEffect(() => {
		dispatch(getPodList({ limit })).then((res) => {
			setDataSource(res?.rows);
			setTotalCount(res?.count);
		});
	}, [dispatch, limit]);

	const fetchMoreData = () => {
		const total_counts = total_count;
		const DSDataaSource = DataSource.length;
		console.log(total_counts, DSDataaSource);
		if (DSDataaSource < total_counts) {
			SetLimit(limit + 10);
			apiFunc();
		} else {
			toaster.error(`End of the page`);
		}
	};
	useEffect(() => {
		dispatch(getPodList({ limit, offset: 0, status: filter })).then((res) => {
			setDataSource(res?.rows);
			setTotalCount(res?.count);
		});
	}, [filter]);

	const apiFunc = () => {
		dispatch(getPodList({ limit })).then((resq) => {
			setDataSource(resq?.rows);
			setTotalCount(resq?.count);
		});
	};

	const cardHeader = {
		fontSize: '12px',
		color: '#888383',
		marginBottom: '5px',
	};
	const cardValue = {
		fontSize: '16px',
		color: '#000',
		fontWeight: '500',
		marginTop: '20px',
		maxWidth: '98px',
		overflowWrap: 'anywhere',
	};

	const cardValueData = {
		color: '#000',
		fontWeight: '500',
		marginTop: '20px',
		fontSize: '12px',
	};

	const loadMore = {
		float: 'right',
		paddingTop: '8px',
		marginTop: '5px',
	};

	const tripID = {
		color: '#1cbdf6',
		fontWeight: '800',
	};

	const DateFormat = 'DD-MM-YYYY';
	const TIME_FORMAT = 'hh:mm a';

	function getLocalDate(date) {
		return formatApprovalDate(date, DateFormat);
	}

	function getLocalTime(time) {
		return formatApprovalTime(time, TIME_FORMAT);
	}

	const padding35 = {
		padding: '5px 10px',
		width: '130px',
	};
	const vdgicon = {
		margin: '30px 5px',
	};
	const getStatusColor = (status) => {
		switch (status) {
			case 'Accepted':
				return '#34C759';
			case 'Pending':
				return '#FF9500';
			case 'Rejected':
				return '#FF3B30';
			default:
				return 'black';
		}
	};
	const getTripCard = (item, index) => (
		<Box className="apporval-card" key={index}>
			<Flex>
				<Box style={vdgicon}>
					<Box>
						<SVG.AdhocAppprvalIcons width="26px" />
					</Box>
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Project Location </Col>
					<Col style={cardValue}> {item?.project_location} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> City</Col>
					<Col style={cardValue}> {item?.city} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Vendor name</Col>
					<Col style={cardValue}> {item?.vendor_name} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Vehicle No</Col>
					<Col style={cardValue}>
						<Box style={{ lineHeight: '2' }}>
							<Text overFlow="hidden" style={{ fontSize: '12px' }}>
								{item?.vehicle_type}
							</Text>
							<Text overFlow="hidden" style={{ color: '#787272' }}>
								{item?.vehicle_number}
							</Text>
						</Box>
					</Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Start </Col>
					<Col style={cardValueData}>
						<Text overFlow="hidden" style={{ fontSize: '12px' }}>
							{getLocalDate(item?.start_date)}
						</Text>
						<Text overFlow="hidden" style={{ color: '#787272' }}>
							{getLocalTime(item?.start_date)}
						</Text>{' '}
					</Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> End </Col>
					<Col style={cardValueData}>
						<Text overFlow="hidden" style={{ fontSize: '12px' }}>
							{getLocalDate(item?.end_date)}
						</Text>
						<Text overFlow="hidden" style={{ color: '#787272' }}>
							{getLocalTime(item?.end_date)}
						</Text>
					</Col>{' '}
				</Box>

				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}>Created By </Col>
					<Col style={cardValue}> {item?.created_by} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Driver Name </Col>
					<Col style={cardValue}> {item?.driver_name} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Trip ID </Col>
					<Col style={cardValue}>
						{' '}
						<Box style={tripID}> {item?.trip_id} </Box>
					</Col>{' '}
				</Box>
				<Box style={padding35}>
					<Box
						style={{
							height: '100%',
							width: '100%',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						{' '}
						<PodViewerModal
							id={item.id}
							data={{
								project_location: item?.project_location,
								city: item?.city,
								vendor_name: item?.vendor_name,
								additional_charges: item?.additional_charges,
								status: item?.status,
								trip_id: item?.trip_id,
								driver_name: item?.driver_name,
								driver_pod_keys: item?.driver_pod_keys,
								por_approval_status: item?.por_approval_status,
							}}
						/>
					</Box>
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Status </Col>
					<Col style={cardValue}>
						{' '}
						<Box
							style={{
								color: getStatusColor(item?.status),
							}}
						>
							{' '}
							{item?.status || '-'}
						</Box>
					</Col>{' '}
				</Box>
			</Flex>
			{item?.rejection_reason && (
				<Box
					style={{
						backgroundColor: '#FF3B30',
						display: 'flex',
						alignItems: 'center',
						gap: '6px',
						padding: '8px 32px',
						width: '100%',
					}}
				>
					<MessageOutlined style={{ color: '#fff', fontSize: '20px' }} />
					<Text
						style={{
							color: '#fff',
							fontSize: '12px',
							fontWeight: '500',
							fontFamily: 'Inter, sans-serif',
						}}
					>
						Reason for Rejection :
					</Text>
					<Text
						style={{
							color: '#fff',
							fontSize: '12px',
							fontWeight: '400',
							fontFamily: 'Inter, sans-serif',
						}}
					>
						{item?.rejection_reason}
					</Text>
				</Box>
			)}
		</Box>
	);

	function getLenght() {
		const tot = total_count - DataSource.length;
		return tot > 0;
	}

	const leftShift = {
		float: 'right',
	};
	const boxmodal = {
		width: '100%',
		height: '50px',
		padding: '10px',
	};

	const { Search } = Input;

	const LtSearchBar = styled(Search)`
		border: none;
	`;

	const [searchVal, SetsearchVal] = useState(undefined);

	function setterFunction(e) {
		SetsearchVal(e.target.value);
	}

	function searchPOD(val) {
		if (val) {
			dispatch(getPodList({ limit, offset: 0, query_str: val })).then((res) => {
				setDataSource(res?.rows);
				setTotalCount(res?.count);
			});
		} else {
			dispatch(getPodList({ limit, offset: 0 })).then((res) => {
				setDataSource(res?.rows);
				setTotalCount(res?.count);
			});
		}
	}
	return (
		<Box>
			<Box>
				<Flex justifyContent="space-between" mt={3}>
					<Box flex="0 0 20%" marginRight="10px">
						<LtSearchBar
							placeholder="Search"
							enterButton="Search"
							value={searchVal}
							allowClear
							autoFocus
							onChange={(val) => setterFunction(val)}
							onSearch={(val) => searchPOD(val)}
						/>
					</Box>

					<Flex></Flex>
					<Box style={boxmodal}>
						<Box style={leftShift}>Total Items: {DataSource.length}</Box>
					</Box>
				</Flex>
			</Box>
			<Box>
				<Flex justifyContent="flex-end" style={{ margin: '10px 10px' }}>
					<PopoverWrapper
						content={
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									gap: '5px',
								}}
							>
								<PopoverButton
									fontWeight="bold"
									type="button"
									onClick={() => setFilter('')}
								>
									All
								</PopoverButton>
								<PopoverButton
									color="#FF9500"
									fontWeight="bold"
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
									type="button"
									onClick={() => setFilter('Pending')}
								>
									<div
										style={{
											height: '8px',
											width: '8px',
											borderRadius: '9999px',
											backgroundColor: '#FF9500',
											marginRight: '10px',
										}}
									/>
									Pending
								</PopoverButton>
								<PopoverButton
									type="button"
									onClick={() => setFilter('Accepted')}
									color="#34C759"
									fontWeight="bold"
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									<div
										style={{
											height: '8px',
											width: '8px',
											borderRadius: '9999px',
											backgroundColor: '#34C759',
											marginRight: '10px',
										}}
									/>
									Accepted
								</PopoverButton>
								<PopoverButton
									color="#FF3B30"
									fontWeight="bold"
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
									type="button"
									onClick={() => setFilter('Rejected')}
								>
									<div
										style={{
											height: '8px',
											width: '8px',
											borderRadius: '9999px',
											backgroundColor: '#FF3B30',
											marginRight: '10px',
										}}
									/>
									Rejected
								</PopoverButton>
							</div>
						}
					>
						<button
							type="button"
							style={{
								display: 'flex',
								color: 'black',
								alignItems: 'center',
								backgroundColor: 'transparent',
								borderRadius: '4px',
								padding: '3px 9px',
								border: '1px solid #C6C6C8',
								cursor: 'pointer',
							}}
						>
							<FilterFilled style={{ marginRight: '3px' }} /> Filter
						</button>
					</PopoverWrapper>
				</Flex>
			</Box>
			<Box>
				<div
					style={{
						overflow: 'auto',
					}}
				>
					{/* <InfiniteScroll dataLength={100} next={fetchMoreData} hasMore>
						{DataSource.map((item, index) =>
							// eslint-disable-next-line react/jsx-key
							getTripCard(item, index)
						)}
					</InfiniteScroll> */}
					{DataSource.length > 0 && (
						<Box>
							{' '}
							{DataSource.map((item, index) =>
								// eslint-disable-next-line react/jsx-key
								getTripCard(item, index)
							)}{' '}
						</Box>
					)}
					{DataSource.length === 0 && (
						<Box style={{ textAlign: 'center' }}>
							{' '}
							<Text style={{ color: '#8a3a3', fontSize: '18px' }}> No Data</Text>
						</Box>
					)}
				</div>
				{DataSource.length > 0 && (
					<div style={loadMore}>
						{getLenght && (
							<Button
								onClick={fetchMoreData}
								borderRadius="4px"
								backgroundColor="#18405d"
							>
								Load More ( Next 10 items )
							</Button>
						)}
					</div>
				)}
			</Box>
		</Box>
	);
}

PODTaskForm.propTypes = {};
